import React, { useState } from "react";
import { Button, Col, DatePicker, Form, Row } from "antd";
import { FormBox, InputBox } from "../../../../components/AntdAddons";
import { SearchOutlined } from "@ant-design/icons";
import dayjs, { Dayjs } from "dayjs";
import { disabledSaveBtn } from "../../../../config/Global";

const SearchList: React.FC<any> = (props) => {
  const { getList } = props;

  const [form] = Form.useForm();

  const [loading, setLoading] = useState<boolean>(false);
  const [disabledClear, setDisabledClear] = useState(true);
  const [disabledSearch, setDisabledSearch] = useState(true);

  const handleSubmit = (data) => {
    setLoading(true);
    let from_date;
    let to_date;

    if (data?.from_date) {
      from_date = dayjs(data?.from_date).format("YYYY-MM-DD");
    }
    if (data?.to_date) {
      to_date = dayjs(data?.to_date).format("YYYY-MM-DD");
    }

    const payload = {
      number_type: data?.number_type,
      from_date: from_date ?? "",
      to_date: to_date ?? "",
    };

    if (payload) {
      setLoading(false);
      getList(payload);
      setDisabledClear(false);
    }
  };

  // for validation
  const handleChange = () => {
    form
      .validateFields()
      .then(() => {
        const isDisabled = disabledSaveBtn(form);
        setDisabledSearch(isDisabled);
      })
      .catch((e: any) => {
        setDisabledSearch(true);
        console.warn(e);
      });
  };

  const disabledDate = (current: Dayjs) => {
    // Can not select days after today
    return current && current.isAfter(dayjs().endOf("day"));
  };

  return (
    <FormBox
      className="filterForm"
      form={form}
      onFinish={handleSubmit}
      onChange={handleChange}
      validateTrigger={["onBlur", "onInput"]}
      autoComplete="off"
    >
      <Row gutter={20} align={"middle"}>
        <Col xs={12} md={12} lg={8} xl={4}>
          <InputBox.Select
            label="Number Type"
            name={"number_type"}
            allowClear
            showSearch
            placeholder="Select Number Type"
            tooltip="Select Number Type"
            options={{
              list: [
                {
                  id: "mobile",
                  label: "Mobile",
                },
                {
                  id: "fixed",
                  label: "Fixed",
                },
                {
                  id: "both",
                  label: "Both",
                },
              ],
              valueKey: "id",
              textKey: "label",
            }}
            onChange={handleChange}
          />
        </Col>

        <Col xs={12} md={12} lg={8} xl={4}>
          <Form.Item label="Select From Date" name={"from_date"}>
            <DatePicker
              placeholder={"Select From Date"}
              disabledDate={disabledDate}
              onChange={handleChange}
            />
          </Form.Item>
        </Col>
        <Col xs={12} md={12} lg={8} xl={4}>
          <Form.Item label="Select To Date" name={"to_date"}>
            <DatePicker
              placeholder={"Select To Date"}
              disabledDate={disabledDate}
              onChange={handleChange}
            />
          </Form.Item>
        </Col>

        <Col xs={12} md={12} lg={6} xl={3}>
          <Button
            type="primary"
            htmlType="submit"
            loading={loading}
            disabled={disabledSearch}
          >
            <SearchOutlined /> Search
          </Button>
        </Col>
        <Col xs={12} md={12} lg={6} xl={3}>
          <Button
            type="default"
            htmlType="reset"
            disabled={disabledClear}
            onClick={() => {
              getList();
              form.resetFields();
              setDisabledSearch(true);
              setDisabledClear(true);
            }}
          >
            Clear
          </Button>
        </Col>
      </Row>
    </FormBox>
  );
};

export default SearchList;
